import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-需求分解",
  "use": "icon-需求分解-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-需求分解\"><path fill=\"none\" d=\"M0 0h18v18H0z\" data-name=\"矩形 5964\" /><path d=\"M4.269 9h9.462V5.846h-3.149V2.692H4.269ZM2.692 9V1.9a.784.784 0 0 1 .785-.785h7.888l3.942 3.942v3.942h1.575v1.582H1.115V9zm-.788 3.154h1.578v4.727H1.904Zm12.616 0h1.577v4.727H14.52Zm-3.154 0h1.577v4.727h-1.577Zm-3.154 0h1.577v4.727H8.212Zm-3.154 0h1.577v4.727H5.058z\" data-name=\"路径 4262\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol